import { Field, TextInput, TextArea, SectionCard, ListAddBtn, ListRemoveBtn } from "./_shared";
import ImageUploadField from "./ImageUploadField";

export default function EditPhotoGallery({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const setImage = (i, key, v) => {
    const images = [...(value.images || [])];
    images[i] = { ...images[i], [key]: v };
    set("images", images);
  };
  const addImage = () => set("images", [...(value.images || []), { url: "", alt: "" }]);
  const removeImage = (i) => set("images", (value.images || []).filter((_, idx) => idx !== i));

  return (
    <SectionCard title="Galeria de Fotos">
      <div className="space-y-5">
        <Field label="Overline"><TextInput value={value.overline} onChange={(v) => set("overline", v)} testId="photo-overline-input" /></Field>
        <Field label="Título"><TextInput value={value.title} onChange={(v) => set("title", v)} testId="photo-title-input" /></Field>
        <Field label="Subtítulo"><TextArea value={value.subtitle} onChange={(v) => set("subtitle", v)} rows={2} testId="photo-subtitle-input" /></Field>

        <div>
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs tracking-[0.2em] uppercase text-onyx/60">Fotos</span>
            <ListAddBtn onClick={addImage} label="Adicionar foto" testId="photo-add-image" />
          </div>
          <div className="space-y-4">
            {(value.images || []).map((img, i) => (
              <div key={i} data-testid={`photo-row-${i}`} className="border border-border p-4 space-y-3 relative">
                <div className="absolute top-3 right-3"><ListRemoveBtn onClick={() => removeImage(i)} testId={`photo-remove-${i}`} /></div>
                <ImageUploadField label="Imagem" value={img.url} onChange={(v) => setImage(i, "url", v)} testId={`photo-img-${i}`} />
                <Field label="Texto alternativo"><TextInput value={img.alt} onChange={(v) => setImage(i, "alt", v)} testId={`photo-alt-${i}`} /></Field>
              </div>
            ))}
          </div>
        </div>
      </div>
    </SectionCard>
  );
}
